import { service } from '.';

export default {
  getAllForMap: (data) => service.post('/works/maps', data),
  getAll: (data) => service.post('/works/search', data),
  getAllSpecialWorks: () => service.get('/specialWorks'),
  getSupervisorLeaderWorks: (data) => service.post('/showpublics/search', data),
  getAllOrganazations: () => service.get('/users/search'),
  getNewWorksSecretary: (data) =>
    service.post('/works/groupsecretary/new', data),
  getSentWorksSecretary: (data) =>
    service.post('/works/groupsecretary/send', data),
  getSpecialWorksSupervisor: (data, type) =>
    service.post(`/works/supervisor/${type}`, data),
  getTotal: (data) => service.post('/mobilereports/sendnew', data),
  getWorkDays: (data) => service.post('/works/date', data),
  getWorkDaysForSupervisorLeader: (data) =>
    service.post('/works/showpublicdate', data),
  getOne: (id) => service.get(`/works/${id}`),
  create: (data) => service.post(`/works`, data),
  update: (id, data) => service.put(`/works/${id}`, data),
  updateSupervisorLeaderWork: (id, data) =>
    service.put(`/works/leader/${id}`, data),
  delete: (data) => service.post('/works/backup', data),
  deleteWork: (id) => service.delete(`/works/${id}`),
  deleteSiteWork: (id) => service.delete(`/showpublics/${id}`),
  deleteImage: (data) => service.post('/deleteFiles', data),
  deleteOldImage: (data) => service.post('/deleteFiles/old', data),
  createTag: (data) => service.post('/tags', data),
};
